import { render, staticRenderFns } from "./career-list.vue?vue&type=template&id=4c130e28&scoped=true&"
import script from "./career-list.vue?vue&type=script&lang=js&"
export * from "./career-list.vue?vue&type=script&lang=js&"
import style0 from "./career-list.vue?vue&type=style&index=0&id=4c130e28&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c130e28",
  null
  
)

export default component.exports